import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators, FormGroup, FormArray } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { DataService } from "src/app/shared/Services/data.service";
import {
  MustMatch,
  ngxphoneNumberValidator,
} from "src/app/shared/Services/custom-validator";
import {
  SearchCountryField,
  CountryISO,
  PhoneNumberFormat,
} from "ngx-intl-tel-input";
import { DndDropEvent } from "ngx-drag-drop";

@Component({
  selector: "app-superUser",
  templateUrl: "./superUser.component.html",
  styleUrls: ["./superUser.component.scss"],
})
export class superUserComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  s_customerForm: FormGroup;


  superCustomerList: any[] = [];
  submitted = false;
  isEditMode: boolean = false;
  selectedCustomerIndex: number = -1;
  showPassword = false;
  availableCustomers: any[] = [];
  customerList: any[] = [];
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  customerId: string = "";
  delcustomerId: string = "";
  constructor(
    private modalService: NgbModal,
    public formBuilder: FormBuilder,
    private dataservice: DataService,
    private toastr: ToastrService
  ) { }

  get type() {
    return this.s_customerForm.controls;
  }

  get selectedCustomers(): any[] {
    return this.s_customerForm.get('customerList').value;
  }

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: "Plant" },
      { label: "Mapping", active: true },
    ];
    this.getSuperCustomers();
    this.getCustomers();
  }

  addSuperCustomer(content: any) {
    this.isEditMode = false;
    this.initializeForm();
    let data = this.customerList.filter(val=>val.isMapped == false)
    this.availableCustomers = [...data]; // Reset available customers
    this.s_customerForm.get('emailId').enable(); // Ensure email is enabled
    this.modalService.open(content, { centered: true });
  }

  editSuperCustomer(customer: any, content: any) {
    this.isEditMode = true;
    this.selectedCustomerIndex = this.superCustomerList.indexOf(customer);
    this.initializeForm();
    this.s_customerForm.patchValue({
      name: customer.name,
      emailId: customer.emailId,
      // password: customer.password,
      // Ensure mobileNumber is a string for ngx-intl-tel-input to parse correctly
      mobileNumber: customer.mobileNumber ? customer.mobileNumber.toString() : "",
      // Create a shallow copy of the array to avoid reference issues
      customerList: customer.customerList ? [...customer.customerList] : []
    });
    this.customerId = customer.id
    // Log detailed validation errors to identify the blocker
    console.log('--- Form Validity Check ---');
    console.log('Form Invalid?', this.s_customerForm.invalid);
    console.log('Selected Count:', this.selectedCustomers?.length);
    Object.keys(this.s_customerForm.controls).forEach(key => {
      const control = this.s_customerForm.get(key);
      const errors = control.errors;
      console.log(`Field: ${key}, Status: ${control.status}, Value:`, control.value);
      if (errors) {
        console.log(`Field: ${key}, Errors:`, errors);
      }
    });
    console.log('---------------------------------');

    // Filter available customers: Master List - Selected List
    const selectedIds = (customer.customerList || []).map((c: any) => c.custId);
    this.availableCustomers = this.customerList.filter((c: any) => !selectedIds.includes(c.custId) && c.isMapped == false);

    // Detailed validation logging
    console.log('Is Form Invalid?', this.s_customerForm.invalid);
    if (this.s_customerForm.invalid) {
      Object.keys(this.s_customerForm.controls).forEach(key => {
        const controlErrors = this.s_customerForm.get(key).errors;
        if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
          });
        }
      });
    }
    console.log('Customer Data:', customer);

    this.s_customerForm.get('emailId').disable(); // Disable email in edit mode
    this.modalService.open(content, { centered: true });
  }

  initializeForm() {
    this.s_customerForm = this.formBuilder.group({
      name: ["", [Validators.required]],
      emailId: ["", [Validators.required, Validators.email]],
      password: ["", this.isEditMode ? [] : [Validators.required]],
      mobileNumber: ["", [Validators.required]],
      customerList: [[]],
    });
    this.submitted = false;
  }

  getSuperCustomers() {
    // Placeholder for fetching super customers.
    // Adjust API endpoint as per actual backend requirements.
    // For now, assuming a similar structure to other fetching methods or local mocking if API is unknown.
    this.dataservice.getSuperCustomer("/oemcustomer").subscribe((res: any) => {
      this.superCustomerList = res;
      console.log(res);
    });
    // Mocking for UI development as per prompt "initial if there is no s_cutomer array need to show no super customer available"
    // this.superCustomerList = [{
    //   "supercustId": "87654kjhguy76",
    //   "name": "Sigma",
    //   "emailId": "sigmacustomer@gmail.com",
    //   "password": "tf156",
    //   "mobileNumber": "9845616559",
    //   "customerList": [
    //     {
    //       custId: 'GNVJH',
    //       name: 'Sigma1'
    //     },
    //     {
    //       custId: 'TYGHJ',
    //       name: 'Sigma2'
    //     }
    //   ]
    // }];
  }

  getCustomers() {
    this.dataservice.getCustomerList("customers").subscribe((res) => {
      console.log(res);
      if (res) {
        this.customerList = res['customerList']
        this.toastr.success("featched customer list")
        // this.usersData = res;
      } else {
        this.customerList = []

        // this.usersData = [];
      }
      (error) => {
        console.log(error);

        // this.errmsg = "Server Unreachable";
        // this.usersData = [];
        this.toastr.error("Server Unreachable");
      };
    });
    // this.customerList = [
    //   {
    //     "custId": "BYX43",
    //     "name": "Sigma1",
    //   },
    //   {
    //     "custId": "FMPY8",
    //     "name": "Sigma2",
    //   },
    //   {
    //     "custId": "BYX23",
    //     "name": "Sigma3",
    //   },
    //   {
    //     "custId": "FMsY8",
    //     "name": "Sigma4",
    //   },
    //   {
    //     "custId": "FIsY8",
    //     "name": "Sigma5",
    //   }
    // ];
  }
  deleteSuperCustomer(customer: any, content: any) {
    console.log(customer, content)
    this.delcustomerId = customer.supercustId
    this.modalService.open(content, { centered: true });
  }
  deleteSuperCustomerId(customer: any) {
    console.log(customer)
    this.dataservice.deleteSuperCustomer(`/oemcustomer/${this.delcustomerId}`).subscribe(res => {
      if (res.status == 200) {
        this.toastr.success(res.message);
        this.modalService.dismissAll();
        this.getSuperCustomers();
            this.getCustomers()

        this.delcustomerId = ""
      } else {
        console.log(res);
        this.toastr.error(res.message);
      }
    });
  }
  saveData() {
    this.submitted = true;
    if (this.s_customerForm.valid) {
      if (this.selectedCustomers.length <= 1) {
        this.toastr.error("Please select at least 2 plants.");
        return;
      }
      const formData = this.s_customerForm.getRawValue(); // Get value even if disabled

      if (this.isEditMode) {
        // Mock Update Logic
        if (this.selectedCustomerIndex > -1) {
          // Extract mobile number if it's an object (ngx-intl-tel-input)
          if (formData.mobileNumber && typeof formData.mobileNumber === 'object') {
            formData.mobileNumber = formData.mobileNumber.e164Number || formData.mobileNumber.number;
          }
          this.superCustomerList[this.selectedCustomerIndex] = formData;


          // const customerWithE164 = this.mapMobileToE164(formData);
          // console.log(formData, this.customerId);
          this.dataservice.updateSuperCustomer(`/oemcustomer/${this.customerId}`, formData).subscribe((res) => {
            if (res.status == 200) {
              this.toastr.success("Super Customer Updated Successfully");
              this.modalService.dismissAll();
              this.getSuperCustomers();
            this.getCustomers()
              this.customerId = ""
            } else {
              console.log(res);
              this.toastr.error(res?.message ? res?.message :"Super Customer Updated Failed");
            }
          },
           (err) => {
          this.toastr.error(err?.message ? err?.message :"Super Customer Updated Failed");
        });



          this.toastr.success("Super Customer Updated (Mock)");
        }
      } else {
        // Check for duplicate email
        const emailExists = this.superCustomerList.some(c => c.emailId === formData.emailId);
        if (emailExists) {
          this.toastr.error("Email already exists!");
          return;
        }
        console.log(formData, this.s_customerForm.value);
        // API call to save data
        const customerWithE164 = this.mapMobileToE164(formData);
        console.log(customerWithE164);
        this.dataservice.saveSuperCustomer("/oemcustomer", customerWithE164).subscribe(
          (res) => {
          if (res.status == 201) {
            this.toastr.success("Super Customer Added Successfully");
            this.modalService.dismissAll();
            this.getSuperCustomers();
            this.getCustomers()
          } else {
            console.log(res);
            this.toastr.error(res?.message ? res?.message :"Super Customer Added Failed");
          }
        },
        (err) => {
          this.toastr.error(err?.message ? err?.message :"Super Customer Added Failed");
        }
      );
        // this.dataservice.post("api/super-customer", formData).subscribe(res => {
        //   this.toastr.success("Super Customer Added Successfully");
        //   this.modalService.dismissAll();
        //   this.getSuperCustomers();
        // });

        // For demonstration of UI logic:
        // Extract mobile number if it's an object (ngx-intl-tel-input)
        // if (formData.mobileNumber && typeof formData.mobileNumber === 'object') {
        //   formData.mobileNumber = formData.mobileNumber.e164Number || formData.mobileNumber.number;
        // }
        // this.superCustomerList.push(formData);
        // this.toastr.success("Super Customer Added (Mock)");
      }
      this.modalService.dismissAll();
      this.isEditMode = false; // Reset mode
    }
  }
  mapMobileToE164(customer) {
    return {
      ...customer,
      mobileNumber: customer.mobileNumber?.e164Number ?? null
    };
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  cancel() {
    this.isEditMode = false;
    this.modalService.dismissAll();
  }

  onDrop(event: DndDropEvent, list?: any[]) {
    if (list && (event.dropEffect === "copy" || event.dropEffect === "move")) {
      let index = event.index;
      if (typeof index === "undefined") {
        index = list.length;
      }
      list.splice(index, 0, event.data);

      // Trigger change detection/form update if it's the selected list
      if (list === this.selectedCustomers) {
        this.s_customerForm.get('customerList').setValue([...list]);
        this.s_customerForm.get('customerList').updateValueAndValidity();
      }
    }
  }

  onDragged(item: any, list: any[], effect: string) {
    if (effect === "move") {
      const index = list.indexOf(item);
      if (index !== -1) {
        list.splice(index, 1);

        // Trigger change detection/form update if it's the selected list
        if (list === this.selectedCustomers) {
          this.s_customerForm.get('customerList').setValue([...list]);
          this.s_customerForm.get('customerList').updateValueAndValidity();
        }
      }
    }
  }
}
